import {
    StrollerProductGalleryState,
    initialStrollerProductGalleryState,
    initialStrollersProductGalleryState,
} from "@/mk2/apps/strollers/containers/StrollerProductGallery/StrollerProductGallery.reducers";
import { AppState } from "@/mk2/reducers";

export const getStrollerProductGalleryState = (
    state: AppState,
    strollerSlug: string,
    strollerVariantId: number | null,
): StrollerProductGalleryState =>
    (state.containers.strollers.strollersProductGallery || initialStrollersProductGalleryState)
        .pages[`${strollerSlug}/${strollerVariantId}`] || initialStrollerProductGalleryState;
